<template>
  <div>
    <h2 class="headerPosition" style="margin-bottom:20px">Profile Information</h2>
    <v-alert
      v-model="alert"
      type="error"
      style="text-align:start;margin:10px auto 10px auto"
      width="400px"
    >
      {{ message }}
    </v-alert>
    <v-text-field
      label="Full name"
      v-model="fullname"
      outlined
      color="#e50914"
      style="margin:auto;border-radius:10px;width:400px"
    />
    <v-text-field
      label="Email"
      v-model="email"
      outlined
      color="#e50914"
      style="margin:auto;border-radius:10px;width:400px"
    />
    <v-textarea
      label="Bio"
      v-model="bio"
      outlined
      color="#e50914"
      style="margin:auto;border-radius:10px;width:400px"
    />

    <v-select
      v-model="country"
      :items="currency"
      :item-text="'country'"
      :item-value="'code'"
      label="Select Your Country"
      outlined
      color="#e50914"
      hint="Your country will determine your currency"
      style="text-align:start;margin:auto;border-radius:10px;width:400px"
    />
    <div style="text-align:center">
    <v-btn
      x-large
      width="286px"
      class="mt-2 text-center white--text"
      style="margin:auto"
      rounded
      color="#e50914"
      @click="toPayment()"
      :loading="loading"
    >
      Continue
      <v-icon color="white" class="ml-2">mdi-arrow-right</v-icon>
    </v-btn>
    </div>
  </div>
</template>

<script>
import {
  getAuth,
  onAuthStateChanged,
} from "firebase/auth";

export default {
  name: "ProfileDetails",
  data() {
    return {
      fullname: "",
      country: "",
      email: "",
      image:"",
      bio:"I'm a Badass African creative that deserves your tips 😅. Tip me to subscribe to my email list and receive exclusive, premium content from me.",
      loading: false,
      currency: [
        { country: "Nigeria", code: "NGN" },
        { country: "America", code: "USD" },
        { country: "Benin", code: "CFA" },
        { country: "Burkina Faso", code: "CFA" },
        { country: "Burundi", code: "BIF" },
        { country: "Cameroon", code: "CFA" },
        { country: "Canada", code: "CAD" },
        { country: "Congo", code: "CDF" },
        { country: "Cape Verde", code: "CVE" },
        { country: "Dubai", code: "AED" },
        { country: "Europe", code: "Euro" },
        { country: "England", code: "GBP" },
        { country: "Gambia", code: "GMD" },
        { country: "Ghana", code: "GHS" },
        { country: "Guinea", code: "GNF" },
        { country: "Guinea Bissau", code: "CFA" },
        { country: "Ivory Coast", code: "CFA" },
        { country: "Kenya", code: "KES" },
        { country: "Liberia", code: "LRD" },
        { country: "Malawi", code: "MWK" },
        { country: "Mali", code: "CFA" },
        { country: "Malaysia", code: "MYR" },
        { country: "Mozambique", code: "MZN" },
        { country: "Niger", code: "CFA" },
        { country: "Rwanda", code: "RWF" },
        { country: "Sierra Leone", code: "SLL" },
        { country: "Sao Tome", code: "STD" },
        { country: "Saudi Arabia", code: "SAR" },
        { country: "Senegal", code: "CFA" },
        { country: "South Africa", code: "ZAR" },
        { country: "Togo", code: "CFA" },
        { country: "Uganda", code: "UGX" },
        { country: "United States of America", code: "USD" },
        { country: "Zambia", code: "ZMW" },
        { country: "Zimbabwe", code: "ZWD" },
      ],
      message: "",
      alert: false,
    };
  },

  created(){
       const auth = getAuth();
       onAuthStateChanged(auth, (user) => {
      if (user) {
        this.fullname = user.displayName
       this.email = user.email
       this.image = user.photoURL
       this.uid = user.uid
      }
    });
  },

  methods: {
    toPayment() {
      this.loading = true;
      if (this.country != "" && this.fullname != "" && this.email != "") {
        this.loading = false;
        let payLoad = {name:this.fullname,email:this.email,country:this.country,bio:this.bio,image:this.image,uid:this.uid}
        this.$emit('toPayment',payLoad)
      } else if (this.fullname == "") {
        this.$swal({
          title: "Fullname not detected!",
          text: "You need to enter your full name",
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false;
      } else if (this.email == "") {
        this.$swal({
          title: "Email is missing!",
          text: "You need to enter your email",
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false;
      } else if (this.country == "") {
        this.$swal({
          title: "Choose your country!",
          text: "Please select your country",
          icon: "error",
          confirmButtonText: "Ok",
        });
        this.loading = false;
      }
    },
  },
};
</script>
